import permissionMixin from '../../mixins/permission-mixin.js'
import {PERMS} from '../../config/permissions.js'

export default {
  mixins: [permissionMixin],
  props: {
    label: {
      type: String,
      default: null
    }
  },
  computed: {
    showButton () {
      if (this.checkPerms.indexOf(PERMS.CREATE) > -1 && this.checkPerms.indexOf(PERMS.EDIT) > -1) {
        return this.userCanWrite
      } else if (this.checkPerms.indexOf(PERMS.EDIT) > -1) {
        return this.userCanEdit
      } else if (this.checkPerms.indexOf(PERMS.CREATE) > -1) {
        return this.userCanCreate
      } else if (this.checkPerms.indexOf(PERMS.DELETE) > -1) {
        return this.userCanDelete
      }
      return false
    }
  },
  methods: {
    onClick ($event) {
      this.$emit('click', $event)
    }
  }
}
